import React from 'react';
import { loginRequest } from "../authConfig";
import { MsalContext, IMsalContext } from "@azure/msal-react";
import { Button, Menu, MenuItem, MenuList, MenuPopover, MenuTrigger, SplitButton } from '@fluentui/react-components'
import { MenuButtonProps } from "@fluentui/react-components";

export interface SignInButtonProps
{
}

export interface SignInButtonState
{
}

export class SignInButton extends React.Component<SignInButtonProps, SignInButtonState>
{
    context!: IMsalContext;
    static contextType = MsalContext;

    async doSignin(type: string)
    {
        if (type === "popup")
            await this.context.instance.loginPopup(loginRequest);
        else if (type === "redirect")
            await this.context.instance.loginRedirect(loginRequest);
    }

    render()
    {
        const primaryActionButtonProps = { onClick: () => this.doSignin("popup") };

        const menuTrigger = (triggerProps: MenuButtonProps) => (
            <SplitButton menuButton={triggerProps} primaryActionButton={primaryActionButtonProps}>
                Sign in
            </SplitButton>);

        return (
            <div>
                <Menu positioning="below-end">
                    <MenuTrigger disableButtonEnhancement>
                        {menuTrigger}
                    </MenuTrigger>
                    <MenuPopover>
                        <MenuList>
                            <MenuItem onClick={() => this.doSignin("popup")}>Popup</MenuItem>
                            <MenuItem onClick={() => this.doSignin("redirect")}>Redirect</MenuItem>
                        </MenuList>
                    </MenuPopover>
                </Menu>
            </div>
        );
    }
}